/** Agent-facing note when the user prompt includes supported integration URLs. */
export function buildIntegrationContentAgentPromptNote(sessionId: string): string {
  const sessionRef = sessionId.trim();
  return [
    'The user message includes link(s) to external integration resources (Linear, GitHub, Jira, Notion, Slack thread, Zoom, or Asana).',
    'Use the get_integration_content MCP tool on the buildautomaton-bridge server to fetch the full content of each link.',
    `When calling the tool, pass sessionId "${sessionRef}" and the URL as url.`,
    'By default the tool links the fetched URL as this session external ticket when the session has none yet. Pass associateAsSessionTicket: false when fetching additional links for context only (after the primary ticket is linked, or when you do not want association).',
    'If the tool reports unsupported_url, do not retry with the same URL. If it reports integration_reconnect_required, ask the user to reconnect the integration in workspace settings. If it reports temporarily_unavailable, you may retry later.',
  ].join('\n');
}

/** Insert the integration-content note into an agent prompt (fork preamble or plain prompt). */
export function injectIntegrationContentAgentPromptNote(agentPrompt: string, sessionId: string): string {
  const note = buildIntegrationContentAgentPromptNote(sessionId);
  const marker = '\nUser request:\n';
  const idx = agentPrompt.indexOf(marker);
  if (idx >= 0) {
    return `${agentPrompt.slice(0, idx)}\n${note}${agentPrompt.slice(idx)}`;
  }
  return `${note}\n\n${agentPrompt.trim()}`;
}
